// extracted by mini-css-extract-plugin
export default {"magnifierContainer":"MagnifierImageList_magnifierContainer__wIN8Z"};